<template>
  <div>
    <catalog-multi-select
      ref="catalog_select"
      catalog-name="вид занятости"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-list="getItems"
      :can-create-catalog="canEditEmploymentCategory()"
      :drop-up="dropUp"
      @onSelect="$emit('input', $event)"
      @open-modal="isModalVisible = true"
    />

    <employment-category
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, { PERM } from "../../../utilites/permissions";
    import EmploymentCategory from "./EmploymentCategory.vue";
    import CatalogMultiSelect from "../CatalogMultiSelect.vue";

export default {
  name: "EmploymentCategoriesMultiSelect",
  components: { CatalogMultiSelect, EmploymentCategory },
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  methods: {
    async getItems() {
      const result = await this.getEmploymentCategoriesSearch("");
      return (result && result.data) ? result.data : [];
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.$emit('catalog-created', newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditEmploymentCategory() {
      return this.hasPermission([PERM.CATALOG_EMPLOYMENT_CATEGORY_EDIT]);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/EmploymentCategories/EmploymentCategoriesMultiSelect.vue